import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { browserHistory } from 'react-router';
import PartnerAccessFrequencyTable from './PartnerAccessFrequencyTable';
import { PartnerAccessFrequencyListService } from '../../services/CustomerSuccessKpiListService';

class PartnerAccessFrequencyTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
  };

  constructor(props) {
    super(props);
    PartnerAccessFrequencyListService.load();
  }

  render() {
    return (
      <PartnerAccessFrequencyTable
        loading={
          PartnerAccessFrequencyListService.fetchCurrent.fetching ||
          PartnerAccessFrequencyListService.fetchPrevious.fetching
        }
        values={toJS(
          get(
            PartnerAccessFrequencyListService,
            { segment: 'bySegment', distributor: 'byDistributor' }[this.props.type],
            []
          )
        )}
        feedbackColorRender={PartnerAccessFrequencyListService.getFeedbackColor}
        onSelect={(row) => browserHistory.push(`/kpis/customer-success/${this.props.type}/${row.id}/details`)}
        formatter={PartnerAccessFrequencyListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerAccessFrequencyTableContainer);
